<template>
  <div class="beiAnContainer">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :title="batch ? '角色类型批量处理' : edit ? '修改角色' : '新增角色'"
      :visible.sync="dialogVisible"
      width="756px"
      custom-class="addoredit"
      @close="close"
    >
      <el-form ref="formDataRef" :model="formData" label-width="100px">
        <el-form-item
          v-if="!batch"
          label="角色ID:"
          prop="roleId"
          :rules="[{ required: true, message: '请输入角色ID' }]"
        >
          <el-input
            v-model="formData.roleId"
            :disabled="edit"
            placeholder="请输入角色ID"
          />
        </el-form-item>
        <el-form-item
          v-if="!batch"
          label="角色名称:"
          prop="roleName"
          :rules="[{ required: true, message: '请输入角色名称' }]"
        >
          <el-input
            v-model="formData.roleName"
            placeholder="请输入角色名称"
          />
        </el-form-item>
        <el-form-item
          label="角色类型:"
          prop="roleType"
          :rules="[{ required: true, message: '请选择角色类型' }]"
        >
          <el-select
            v-model="formData.roleType"
            placeholder="请选择角色类型"
            style="width: 100%"
          >
            <el-option
              v-for="(t, i) in types"
              :key="i"
              :label="t.label"
              :value="t.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!batch" label="省份:" prop="province">
          <el-select
            v-model="formData.province"
            placeholder="请选择省份"
            style="width: 100%"
          >
            <el-option
              v-for="(t, i) in provinceData"
              :key="i"
              :label="t.label"
              :value="t.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!batch"
          label="备注:"
          prop="remark"
          style="width: 100%"
        >
          <el-input
            v-model="formData.remark"
            maxlength="200"
            type="textarea"
            placeholder="备注"
          />
        </el-form-item>
        <el-form-item
          style="width: 100%"
          label="菜单权限:"
          prop="resourceIds"
          :rules="[
            {
              required: true,
              validator: validateMenu,
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-checkbox v-model="checked1">展开/折叠</el-checkbox>
          <el-checkbox v-model="checked2">全选/全不选</el-checkbox>
          <el-checkbox v-model="checked3">父子联动</el-checkbox>
          <!-- <el-checkbox v-model="checked3">父子联动</el-checkbox> -->
          <!-- <el-checkbox-group v-model="authority" @change="changed">
            <el-checkbox label="1">展开/折叠</el-checkbox>
            <el-checkbox label="2">全选/全不选</el-checkbox>
            <el-checkbox label="3">父子联动</el-checkbox>
          </el-checkbox-group> -->
        </el-form-item>
        <el-form-item style="width: 100%" label-width="80px">
          <template>
            <div
              class="treebody"
              style="border: solid 1px rgb(242, 242, 242); width: 100%"
            >
              <el-tree
                ref="menuRef"
                show-checkbox
                :data="treeData"
                node-key="id"
                :check-strictly="!checked3"
                :props="defaultProps"
                :default-expand-all="checked1"
                @check="handleCheckChange"
              >
                <span slot-scope="{ node }" class="custom-tree-node">
                  <span> <i class="el-icon-folder" />{{ node.label }} </span>
                </span>
              </el-tree>
            </div>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="loading"
          @click="sureDelete"
        >确 认</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      :close-on-click-modal="false"
      :closeOnPressEscape="false"
      center
      title="分配用户"
      :visible.sync="dialogjsVisible"
      width="1200px"
      @close="close"
      custom-class="fpuesr"
    >
      <el-form
        label-position="left"
        style="width: 95%; margin: 10px auto; justify-content: flex-end"
      >
        <el-form-item label="登录名称:" label-width="80px">
          <el-input v-model="formData.username"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:" label-width="80px">
          <el-input v-model="formData.phone"></el-input>
        </el-form-item>
        <el-form-item
          style="width: 60%; text-align: right; justify-content: flex-end"
          label-width="0px"
        >
          <el-button
            icon="el-icon-refresh-left"
            style="border: solid 1px #409eff; color: #409eff"
            >重置</el-button
          >
          <el-button
            icon="el-icon-search"
            style="border: solid 1px #409eff; color: #409eff"
            >搜索</el-button
          >
          <el-button icon="el-icon-circle-plus-outline" type="primary"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        stripe
        :data="tableData"
        :row-style="{ height: 0 + 'px' }"
        :header-cell-style="{
          'text-align': 'center',
          background: '#eef1f6',
        }"
        :cell-style="{ 'text-align': 'center' }"
        style="width: 95%; margin: auto"
      >
        <el-table-column prop="name" label="登录名称"> </el-table-column>
        <el-table-column prop="yhmc" label="用户名称"> </el-table-column>
        <el-table-column
          prop="section"
          label="邮箱"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="sj" label="手机"> </el-table-column>
        <el-table-column prop="bbdate" label="用户状态"> </el-table-column>
        <el-table-column prop="bbdate" label="创建时间"> </el-table-column>
        <el-table-column label="操作">
          <template>
            <el-button
              icon="el-icon-search"
              size="mini"
              style="
                color: rgb(64, 158, 255);
                border-color: rgb(64, 158, 255);
                border-radius: 30px;
                background-color: rgb(230, 242, 252);
              "
              >取消授权</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventReClick @click="sureDelete"
          >确 认</el-button
        >
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { getResources } from '@/assets/js/resource'
import { getProvince, getRoleType, addRole, updateRole, updateRoleResByRoleType, getRoleTypeResources } from '@/assets/js/role'
export default {
  data() {
    return {
      edit: false,
      batch: false,
      loading: false,
      formData: {
        roleId: '', // -- 角色ID
        roleName: '', // -- 角色名称
        roleType: '', //  -- 角色类型
        provinceName: '', // -- 省份
        province: '', // -- 省份的id
        remark: '', // -- 备注
        cjsj: '', // -- 创建时间
        resourceIds: [] // -- 路由的id （数组）
      },
      checked1: true,
      checked2: false,
      checked3: false,
      authority: [],
      types: [],
      dialogVisible: false,
      dialogjsVisible: false,
      defaultProps: {
        children: 'children',
        label: 'resourceName'
      },
      provinceData: [],
      treeData: [],
      tableData: [
        {
          name: '山东化学品有限公司',
          yhmc: '张丽丽',
          section: '青岛市公安局市南区分局禁毒大队',
          sj: '15132087688',
          zt: '正常',
          bbdate: '2021-10-10',
          bgcs: '2'
        },
        {
          name: '山东化学品有限公司',
          yhmc: '张丽丽',
          section: '青岛市公安局市南区分局禁毒大队',
          sj: '15132087688',
          zt: '正常',
          bbdate: '2021-10-10',
          bgcs: '2'
        }
      ]
    }
  },
  watch: {
    checked1() {
      // setCheckedKeys
      // this.$refs.menuRef.setCheckedKeys()
      // 改变每个节点的状态
      this.changeTreeNodeStatus(this.$refs.menuRef.store.root)
    },
    checked2() {
      this.checkTree(this.checked2)
      this.$nextTick(() => {
        this.handleCheckChange()
      })
    },
    'formData.roleType'() {
      if (this.batch && (this.formData.roleType || this.formData.roleType === 0)) {
        this.loadRoleTypeResource(this.formData.roleType)
      }
    }
  },
  mounted() {
    this.loadRoleType()
    this.loadProvince()
    this.loadResource()
  },
  methods: {
    validateMenu(rule, value, callback) {
      // 附件校验
      if (!this.formData.resourceIds || this.formData.resourceIds.length === 0) {
        callback(new Error('请选择菜单!'))
      } else {
        callback()
      }
    },
    // 改变节点的状态
    changeTreeNodeStatus(node) {
      node.expanded = this.checked1
      for (let i = 0; i < node.childNodes.length; i++) {
        // 改变节点的自身expanded状态
        node.childNodes[i].expanded = this.checked1
        // 遍历子节点
        if (node.childNodes[i].childNodes.length > 0) {
          this.changeTreeNodeStatus(node.childNodes[i])
        }
      }
    },
    changed(a, b, c) {
      console.log(a, b, c)
    },
    expandNodes(node) {
      if (node.parent != null) {
        this.expandNodes(node.parent)
      }
      node.expanded = true
    },
    checkTree(flag = true) {
      for (var i = 0; i < this.$refs.menuRef.store._getAllNodes().length; i++) {
        this.$refs.menuRef.store._getAllNodes()[i].checked = flag
      }
    },
    toggleRowExpansionAll(data) {
      data.forEach((item) => {
        this.$refs.menuRef.toggleRowExpansion(item, this.checked2)
        if (depth > 0 || depth === -1) {
          if (item.children !== undefined && item.children !== null) {
            this.toggleRowExpansionAll(item.children)
          }
        }
      })
    },
    sureDelete() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid) {
          this.loading = true
          const params = Object.assign({}, this.formData)
          let API = addRole
          if (this.edit) {
            API = updateRole
          }
          if (this.batch) {
            API = updateRoleResByRoleType
          }
          API(params).then(res => {
            if (res.status === 200 && res.data.code === '000000') {
              this.$message({
                type: 'success',
                message: this.edit ? '保存成功' : '新增成功'
              })
              this.close()
              this.$emit('refresh')
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    loadResource() {
      getResources().then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.treeData = res.data.data
        }
      })
    },
    loadRoleTypeResource(type) {
      getRoleTypeResources(type).then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.formData.resourceIds = res.data.data
          this.$refs.menuRef.setCheckedKeys(res.data.data)
        }
      })
    },
    loadProvince() {
      getProvince().then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.provinceData = res.data.data
        }
      })
    },
    loadRoleType() {
      getRoleType().then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.types = res.data.data
        }
      })
    },
    handleCheckChange() {
      // console.log(data, checked, indeterminate);
      this.$nextTick(() => {
        this.formData.resourceIds = this.$refs.menuRef.getCheckedKeys()
        this.$refs.formDataRef.validateField('resourceIds')
      })
    },
    show(batch = false, row) {
      this.dialogVisible = true
      this.checked2 = false
      this.checked3 = false
      if (batch) {
        this.batch = true
      } else {
        this.batch = false
        this.edit = !!(row && row.roleId)
        this.formData = Object.assign({}, row)
      }
      this.$nextTick(() => {
        this.checkTree(this.checked2)
        this.$refs.formDataRef.clearValidate()
        if (this.formData.resourceIds) {
          this.$refs.menuRef.setCheckedKeys(this.formData.resourceIds)
        }
      })
    },
    close() {
      this.$refs.formDataRef.clearValidate()
      this.$nextTick(() => {
        this.$refs.formDataRef.resetFields()
        this.dialogVisible = false
      })
      // this.dialogVisible = false;
      // this.dialogjsVisible = false;
    }
  }
}
</script>

<style lang="less" scoped>
.beiAnContainer {
  .treebody {
    height: 400px;
    overflow-y: auto;
  }
  /deep/ .addoredit {
    .el-dialog__body {
      padding: 20px 40px;
      .el-form {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .el-form-item {
          width: 47%;
          .el-form-item__content {
            display: flex;
          }
        }
      }
    }
  }
  /deep/ .fpuesr {
    .el-dialog__body {
      padding: 20px 40px;
      .el-form {
        display: flex;

        .el-form-item {
          width: 30%;
          margin-right: 20px;
          .el-form-item__content {
            display: flex;
          }
        }
      }
    }
  }
  .el-button--primary {
    color: #fff;
    background: #4170ff;
    border-radius: 3px;
    border-color: #4170ff;
  }
}
</style>
